import { nameEncodeMap, nameDecodeMap } from "./mappings";
import { multiply, op, tree } from "./operations";
import { fromRoot, getBase } from "./buildRelatedFields";
import { dollarsFormatter, unitsFormatter } from "./decimalNumFormatter";

export function replacer(name, index) {
  return name.replace(/[ .-]/g, l => {
    if (l === ".") return nameEncodeMap().dot;
    if (l === " ") return nameEncodeMap().single_space;
    return nameEncodeMap().hyphen; // handle hyphen
  });
}

// Code to produce Object of Objects"
export function formStructure(collection, suffixArr) {
  return collection.reduce((acc, pool) => {
    const { availableBalance, availableUnits } = pool;
    const stuff = tree(
      "Dollars",
      op(
        "Units",
        multiply((1 / availableBalance) * availableUnits),
        op("Percentage", multiply((1 / availableUnits) * 100))
      )
    );
    const encodedName = replacer(pool.poolName);
    acc[encodedName] = (function formatPoolFields() {
      const poolObj = fromRoot(
        stuff,
        getBase(stuff, "Dollars", availableBalance)
      );
      for (const suffix in poolObj) {
        if (suffix === "Dollar")
          poolObj[suffix] = dollarsFormatter(poolObj[suffix]);
        if (suffix === "Percentage") poolObj[suffix] = 100;
        if (suffix === "Units")
          poolObj[suffix] = +unitsFormatter(poolObj[suffix]);
      }
      return poolObj;
    })();
    return acc;
  }, {});
}

export function decodeName(name) {
  return name.replace(/(?:[$]|__|\B_\B)/g, l => {
    if (l === "$") return nameDecodeMap().dollar;
    if (l === "_") return nameDecodeMap().underscore;
    return nameDecodeMap().dUnderscore;
  });
}
